import { useTranslation } from 'react-i18next';
import type { CompanyFormData } from 'pages/editor/useCreateCompany';
import { useCreateCompany } from 'pages/editor/useCreateCompany';
import CreateCompanyForm from './CreateCompanyForm';
import { PyEntityCreationModal } from '../PyEntityCreationModal';
import { QueryKeys } from 'utils/queryKeys';
import type { CompanyResponse } from 'services/company-and-contacts/entities';

interface CreateCompanyModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: (payload: { data: CompanyResponse; formData: CompanyFormData }) => void;
}

export default function CreateCompanyModal({ isOpen, onClose, onSuccess }: CreateCompanyModalProps) {
  const { t } = useTranslation();
  const { mutateAsync } = useCreateCompany();
  const initialFormData: CompanyFormData = { name: '' };

  return (
    <PyEntityCreationModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      title={t('document.create_company.title')}
      description={t('document.create_company.description')}
      cancelText={t('document.create_company.cancel')}
      saveText={t('document.create_company.save')}
      FormComponent={CreateCompanyForm}
      initialFormData={initialFormData}
      mutationFn={mutateAsync}
      invalidateQueries={[QueryKeys.getProspectName, QueryKeys.getCompanies]}
      successNotification={{
        title: t('document.create_company.notification.success.title'),
        description: t('document.create_company.notification.success.description'),
      }}
      errorNotification={{
        title: t('document.create_company.notification.errors.save_error_title'),
        description: t('document.create_company.notification.errors.save_error_description'),
      }}
    />
  );
}
